export function parseSymfonyValidationErrors(responseData) {
    var _a;
    if (typeof responseData !== 'object' ||
        responseData === null ||
        !('violations' in responseData) ||
        !Array.isArray(responseData.violations)) {
        return {};
    }
    var payload = responseData;
    return ((_a = payload.violations) !== null && _a !== void 0 ? _a : []).reduce(function (errors, violation) {
        var field = violation.propertyPath;
        var message = violation.title || violation.message;
        if (field && message) {
            errors[field] = message;
        }
        return errors;
    }, {});
}
